import { RoutePermittedRole } from 'constants/AppConst';
import { ROUTE_STRING } from 'constants/RouteString';
import List from './List';

export const webhookRegistrationRoutes = [
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.WEBHOOK_REGISTRATION.LIST],
    element: <List />,
  },
];
